import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/:token?',
    component: () => import('@/views/Demo.vue'),
  },
  {
    path: '/error',
    name: 'error-default',
    component: () => import('@/views/Error/Default.vue'),
    props: route => ({
      error: route.params.error,
    }),
  },
  { path: '*', name: 'error-404', component: () => import('@/views/Error/404.vue') },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

export default router
